export const trimTextToFirstDot = (text = '') => {
    if (text.length < 255) {
        return text;
    }

    const firstDotIndex = text.indexOf('.');

    return text.slice(0, firstDotIndex + 1);
};
